import { RefObject, useLayoutEffect, useRef, useState } from "react";
import { getWatermarkScale } from "./watermarkScale";

export const useWatermarkScale = ({
    pageRef,
    watermarkText,
}: {
    pageRef: RefObject<HTMLDivElement | null>;
    watermarkText: string;
}) => {
    const watermarkRef = useRef<HTMLSpanElement>(null);
    const [watermarkScale, setWatermarkScale] = useState(1);

    useLayoutEffect(() => {
        const watermark = watermarkRef.current;
        const page = pageRef.current;
        if (!watermark || !page) {
            return;
        }
        setWatermarkScale(
            getWatermarkScale({
                textWidth: watermark.offsetWidth,
                textHeight: watermark.offsetHeight,
                pageWidth: page.clientWidth,
            }),
        );
    }, [pageRef, watermarkText]);

    return { watermarkRef, watermarkScale };
};
